<template>
  <a @click="toggleColormap()">
    <div class="icon-stack">
      <i class="fas fa-tint fa-flip-horizontal background" :class="{'white-on-black': whiteOnBlack}"></i>
      <i class="fas fa-tint fa-flip-horizontal foreground" :class="{'white-on-black': whiteOnBlack}"></i>
    </div>
  </a>
</template>

<script>

export default {
  name: 'histolog-color-toggle',
  components: {},
  props: {
    index: String
  },
  data() {
    return {
      channelIndex: 0, // Histolog images always have a single channel index
    };
  },
  computed: {
    imageModule() {
      return this.$store.getters['currentProject/imageModule'](this.index);
    },
    imageWrapper() {
      return this.$store.getters['currentProject/currentViewer'].images[this.index];
    },
    apparentChannels() {
      return this.imageWrapper.colors.apparentChannels;
    },
    isVioletColormap: {
      get() {
        return this.imageWrapper.colorOverlay.violetColormap;
      },
      set(value) {
        this.$store.commit(this.imageModule + 'setVioletColormap', value);
      }
    },
    whiteOnBlack() {
      return !this.isVioletColormap;
    }
  },
  methods: {
    toggleColormap() {
      this.$store.commit(this.imageModule + 'toggleVioletColormap');
    }
  }
}
</script>

<style scoped>
.icon-stack {
  width: 2rem;
  display: inline-block;
}
.icon-stack .background {
  position: relative;
  left: -1px;
  color: white;
}
.icon-stack .foreground {
  position: relative;
  left: -9px;
  color: rgb(150, 0, 255)
}

.icon-stack .background.white-on-black {
  color: black;
}

.icon-stack .foreground.white-on-black {
  color: white;
}
</style>
